import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import moment from 'moment'
import {KTSVG, useDebounce} from '../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import AddNewDedicatedNumber from '.././modal/AddNewDedicatedNumber'
import EditDedicatedNumber from '.././modal/EditDedicatedNumber'
import {
  deleteDedicatedNumberList,
  getDedicatedNumberList,
} from '.././DedicatedNumberSlice/DedicatedNumberSlice'
import {GetGatewayManagementList} from '../../GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import NodataYet from '../../../../Components/NodataYet'
import {Modal} from 'react-bootstrap'

const DedicatedNumberListModel = ({show, handleClose}: any) => {
  //////////////////////////////////All Const///////////////////////////
  const dispatch = useDispatch()

  ////////////////////////////////////////ALL USESTATE//////////////////////////////////
  const [showVirtualNumber, setShowVirtualNumber] = useState(false)
  const [editNumber, setEditNumber] = useState(false)
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [editNumberData, setEditNumberData] = useState<any>({
    country: {value: 'au', label: 'Australia'},
  })
  const [deleteIds, setDeleteIds] = useState<any>()
  const dedicatedNumber = useSelector((state: any) => state?.dedicatedNumber?.dedicatedNumberList)
  const paymentGatewayList = useSelector((state: any) => state?.paymentGateway?.GatewayManagement)
  const userAccList = useSelector((state: any) => state?.UserAccount?.userAccountList?.items)

  const [apply, setApply] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    searchKey: '',
    availability: 'available',
    status: '',
    billingStatus: '',
  })

  const debouncedSearchTerm = useDebounce(page?.searchKey, 3000)

  /////////////////////////////////////USE-EFFECT//////////////////////////////////////
  useEffect(() => {
    dispatch(getDedicatedNumberList(page))
    dispatch(GetGatewayManagementList())
  }, [debouncedSearchTerm, page.page, page.size, apply])

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        deleteDedicatedNumberList({
          id: deleteIds,
        })
      ).then(() => {
        dispatch(getDedicatedNumberList(page))
      })
      setConfirm(false)
    }
  }, [confirm])

  /////////////////////////////////use-MEMO//////////////////////////////////////

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete this dedicated number?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  const VNPopup = useMemo(
    () => (
      <AddNewDedicatedNumber
        show={showVirtualNumber}
        handleClose={() => setShowVirtualNumber(false)}
      />
    ),
    [showVirtualNumber]
  )

  const editVNnumber = useMemo(
    () => (
      <EditDedicatedNumber
        data={editNumberData}
        setData={setEditNumberData}
        show={editNumber}
        page={page}
        handleClose={() => setEditNumber(false)}
      />
    ),
    [editNumber, editNumberData]
  )
  ///////////////////////////////////ALL Function //////////////////////////////

  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }

  return (
    <>
      {VNPopup}
      {editVNnumber}
      {confirmation}
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-900px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h1>Add Dedicated Number</h1>
          <div className='btn btn-icon btn-sm btn-light-primary ms-2' onClick={handleClose}>
            <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-0'>
          <div className='card mb-0'>
            {dedicatedNumber?.length > 0 ? (
              <div className='card-body pt-2'>
                <div className='tab-content'>
                  <div className='table-responsive'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr className='fw-bold text-muted text-uppercase'>
                          <th>Number</th>
                          <th>Type</th>
                          <th>Gateway</th>
                          <th>Status</th>
                          <th>Availability</th>
                          <th className='w-125px min-w-125px mw-125px'>Action</th>
                        </tr>
                      </thead>
                      <tbody className='text-gray-600'>
                        {dedicatedNumber?.map((val: any, id: number) => (
                          <tr key={id}>
                            <td>{val?.audNumber}</td>
                            <td>
                              <span
                                className={`${
                                  val?.type == 'SMS'
                                    ? 'badge badge-light-success '
                                    : 'badge badge-light-info'
                                }`}
                              >
                                {val?.type}
                              </span>
                            </td>
                            <td>
                              {paymentGatewayList?.length > 0 &&
                                paymentGatewayList?.find((key: any) => key?._id == val?.gateway)
                                  ?.gatewayName}
                            </td>
                            <td>
                              <span
                                className={`${
                                  val?.status == 'active'
                                    ? 'badge badge-light-success '
                                    : 'badge badge-light-danger'
                                }`}
                              >
                                {val?.status?.charAt(0).toUpperCase() + val?.status?.slice(1)}
                              </span>
                            </td>
                            <td>
                              <span
                                className={`${
                                  val?.availability == 'available'
                                    ? 'badge badge-light-success '
                                    : val?.availability == 'allocated'
                                    ? 'badge badge-light-info'
                                    : 'badge badge-light-danger'
                                }`}
                              >
                                {val?.availability?.charAt(0).toUpperCase() +
                                  val?.availability.slice(1)}
                              </span>
                            </td>
                            <td className='text-end'>
                              {AuthenticateUser('edit-backend-dedicatednumber') && (
                                <span
                                  onClick={() => {
                                    const editData = {
                                      _id: val?._id,
                                      audNumber: val?.audNumber,
                                      gateway: val?.gateway,
                                      country: val?.country,

                                      billingStatus: val?.billingStatus,
                                      activationTime:
                                        val?.activationTime == null
                                          ? new Date()
                                          : val?.activationTime,
                                      expirationTime:
                                        val?.expirationTime == null
                                          ? new Date()
                                          : val?.expirationTime,
                                      status: val?.status,

                                      assignedUser:
                                        val?.assignedUser !== ''
                                          ? {
                                              value: val?.assignedUser,
                                              label: val?.assignedOwnerName?.[0],
                                            }
                                          : {value: '', label: 'select'},
                                    }

                                    setEditNumber(true)
                                    setEditNumberData({...editData})
                                  }}
                                  className='btn btn-bg-light btn-active-color-primary btn-sm'
                                >
                                  Edit
                                </span>
                              )}
                              {AuthenticateUser('delete-backend-dedicatednumber') && (
                                <span
                                  onClick={() => handleDelete(val?._id)}
                                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm ms-3'
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/general/gen027.svg'
                                    className='svg-icon-3'
                                  />
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <NodataYet />
            )}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default DedicatedNumberListModel
